import { useState, useEffect } from 'react';
import useCookie from 'react-use-cookie';


export default function useJsonCookie(key, initialValue) {

    // Share the cookie across subdomains (e.g. www. and the booking engine) by
    // setting a parent-domain cookie. On a single-label host like "localhost"
    // there's no parent domain, so omit the attribute entirely - a "." domain
    // is invalid and makes the browser silently drop the cookie.
    var separate = window.location.hostname.split('.');
    separate.shift();
    var currentdomain = separate.join('.');
    let cookieSettings = {
        SameSite: 'Lax',
        days: 365,
    };
    if (currentdomain) {
        cookieSettings.domain = "." + currentdomain;
    }

    const [valueer, setter] = useCookie(key, JSON.stringify(initialValue));
    var wrappedSetter = (x) => {
        setter(JSON.stringify(x), cookieSettings);
    }
    // "Remove" resets to the initial value using the same cookie attributes -
    // the raw remover left the value undefined, which then crashed JSON.parse.
    var wrappedRemove = () => wrappedSetter(initialValue);
    // Guard against a missing/empty cookie value so a bad value can't crash the
    // whole widget.
    var unwrappedValue = initialValue;
    try {
        if (valueer != null && valueer !== "" && valueer !== "undefined") {
            unwrappedValue = JSON.parse(valueer);
        }
    } catch {
        unwrappedValue = initialValue;
    }
    return [unwrappedValue, wrappedSetter, wrappedRemove];
}
